import { ApplicationTheme } from "../enums/ApplicationTheme";

export function getApplicationTheme(applicationTheme: ApplicationTheme): ApplicationTheme {
  if (applicationTheme === ApplicationTheme.SYSTEM) {
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? ApplicationTheme.DARK : ApplicationTheme.LIGHT;
  }

  return applicationTheme === ApplicationTheme.DARK ? ApplicationTheme.DARK : ApplicationTheme.LIGHT;
}
